import { Radio, RadioGroup } from '@headlessui/react'
import { Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

import { SelectOrganisationAdminListOrganisationFragment } from '@/graphql/purchase-plus/generated/purchasePlus_graphql'
import { CheckboxIcon } from '@/modules/shared/icons-special/CheckboxIcon'
import { generateOrgName } from '@/modules/shared/utils/generateOrgName'

interface SelectOrganisationAdminListProps {
  organisations: SelectOrganisationAdminListOrganisationFragment[]
  onSelectOrganisation: Dispatch<SetStateAction<number | null>>
}

export default function SelectOrganisationAdminList({
  organisations,
  onSelectOrganisation,
}: SelectOrganisationAdminListProps) {
  const { t } = useTranslation()
  return (
    <RadioGroup data-testid="switch-organisation-options" className="divide-y rounded-md border border-gray-200">
      {organisations.map((organisation) => {
        return (
          <div
            key={organisation.id}
            className="flex w-full cursor-pointer flex-col bg-gray-100 p-3 first:rounded-t-md last:rounded-b-md"
          >
            <Radio
              value={organisation.id}
              onClick={() => onSelectOrganisation(Number(organisation.id))}
              data-testid="switch-organisation-option"
            >
              {({ checked }) => (
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-x-3">
                    <span className="shrink-0">
                      <CheckboxIcon isSelected={checked} />
                    </span>
                    <span>
                      {generateOrgName({
                        name: organisation.name,
                        parent: organisation?.parent,
                      })}
                    </span>
                    {!organisation.isVerified && (
                      <span className="inline-flex cursor-pointer rounded-full bg-gray-600 px-2 py-1 text-center text-xs text-white">
                        {t('general.notVerified', 'Not Verified')}
                      </span>
                    )}
                  </div>
                  {organisation.id}
                </div>
              )}
            </Radio>
          </div>
        )
      })}
    </RadioGroup>
  )
}
